import { AxiosStatic, AxiosError } from "axios";
import moment from "moment"; // TODO: Do we really need this for all the bloat that it causes

import {
  IOwnerTicketInfo,
  IError,
  Roles,
  ShareStatus,
  ErrorTypes,
  IRecipientTicketInfo
} from "../../../interface/IShareInfo";
import { Dispatch, Action } from "redux";
import { errorResponseHandler } from "../../../commons/utils/errorMessagesHandler";

export enum TicketReceivingActionTypes {
  LOAD_TICKET_RECEIVING_DATA_PENDING = "LOAD_TICKET_RECEIVING_DATA_PENDING",
  LOAD_TICKET_RECEIVING_DATA_SUCCESS = "LOAD_TICKET_RECEIVING_DATA_SUCCESS",
  LOAD_TICKET_RECEIVING_DATA_FAILED = "LOAD_TICKET_RECEIVING_DATA_FAILED",
  SUBMIT_TICKET_RECEIVING_PENDING = "SUBMIT_TICKET_RECEIVING_PENDING",
  SUBMIT_TICKET_RECEIVING_SUCCESS = "SUBMIT_TICKET_RECEIVING_SUCCESS",
  SUBMIT_TICKET_RECEIVING_FAILED = "SUBMIT_TICKET_RECEIVING_FAILED",
  UPDATE_CHECKRECEIVE_STATUS = "UPDATE_CHECKRECEIVE_STATUS",
  UPDATE_POST_STEP = "UPDATE_POST_STEP",
  ACCEPT_TICKET_PENDING = "ACCEPT_TICKET_PENDING",
  ACCEPT_TICKET_SUCCESS = "ACCEPT_TICKET_SUCCESS",
  ACCEPT_TICKET_FAILED = "ACCEPT_TICKET_FAILED",
  DECLINE_TICKET_PENDING = "DECLINE_TICKET_PENDING",
  DECLINE_TICKET_SUCCESS = "DECLINE_TICKET_SUCCESS",
  DECLINE_TICKET_FAILED = "DECLINE_TICKET_FAILED"
}

const api_base = "/tickets";

export interface ILoadTicketReceivingDataSuccess {
  type: TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_SUCCESS;
  payload: IOwnerTicketInfo;
}

export interface ILoadTicketReceivingDataFailed {
  type: TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_FAILED;
  error: IError;
}

export interface ILoadTicketReceivingDataPending {
  type: TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_PENDING;
}

export interface ISubmitSharingSuccess {
  type: TicketReceivingActionTypes.SUBMIT_TICKET_RECEIVING_SUCCESS;
}

export interface ISubmitReceivingFailed {
  type: TicketReceivingActionTypes.SUBMIT_TICKET_RECEIVING_FAILED;
}

export interface ISubmitReceivingPending {
  type: TicketReceivingActionTypes.SUBMIT_TICKET_RECEIVING_PENDING;
}

export interface IUpdateCheckReceive {
  type: TicketReceivingActionTypes.UPDATE_CHECKRECEIVE_STATUS;
  payload: boolean;
}

export interface IUpdatePostStep {
  type: TicketReceivingActionTypes.UPDATE_POST_STEP;
  payload: string;
}

export interface IAcceptTicketPending {
  type: TicketReceivingActionTypes.ACCEPT_TICKET_PENDING;
}

export interface IAcceptTicketSuccess {
  type: TicketReceivingActionTypes.ACCEPT_TICKET_SUCCESS;
}

export interface IAcceptTicketFailed {
  type: TicketReceivingActionTypes.ACCEPT_TICKET_FAILED;
  error: IError;
}

export interface IDeclineTicketPending {
  type: TicketReceivingActionTypes.DECLINE_TICKET_PENDING;
}

export interface IDeclineTicketSuccess {
  type: TicketReceivingActionTypes.DECLINE_TICKET_SUCCESS;
}

export interface IDeclineTicketFailed {
  type: TicketReceivingActionTypes.DECLINE_TICKET_FAILED;
  error: IError;
}

const handleAcceptanceSchema = (data: any) => {
  const shareData = {
    shareStatus: ShareStatus.ErrorStatus,
    venueInfo: {
      date: "",
      eventName: "",
      eventDescription: "",
      when: "",
      venueName: "",
      state: "",
      productId: ""
    },
    seatInfo: {
      sectionNumber: "",
      rowNumber: "",
      seatNumber: ""
    },
    ticketGroupId: "",
    ticketId: "",
    sharedFrom: ""
  };

  if (!data || !data.data || !data.data.product || !data.data.seats) {
    return shareData;
  }

  shareData.shareStatus = data.data.current
    ? data.data.current.status
    : ShareStatus.Requested;
  const {
    keywords,
    title,
    venue_state,
    venue_name,
    date,
    when,
    venue_timezone = "",
    id,
  } = data.data.product;
  
  shareData.venueInfo = {
    date,
    eventName: title,
    eventDescription: keywords,
    productId: id,
    venueName: venue_name,
    when: date
      ? moment(date)
          .utcOffset(venue_timezone)
          .format("ddd D MMMM YYYY h:mm A")
      : when,
    state: venue_state
  };
  const { section, row, name } = data.data.seats[0];
  shareData.seatInfo = {
    sectionNumber: section,
    rowNumber: row,
    seatNumber: name
  };

  if (data.data.customer && data.data.customer.name) {
    shareData.sharedFrom = data.data.customer.name;
  }

  shareData.ticketGroupId = data.data.ticketGroupId;
  shareData.ticketId = data.data.ticketId;

  return shareData;
};

export const loadTicketReceivingData = (
  ticketGroupId: string,
  ticketId: string
) => async (dispatch: Dispatch, getState: any, axios: AxiosStatic) => {
  dispatch<ILoadTicketReceivingDataPending>({
    type: TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_PENDING
  });

  try {
    const isLoggedin = !!getState().authData.data.token;
    const publicPath = isLoggedin ? "" : "/public";
    const url = ticketId
      ? `${api_base}/${ticketGroupId}/share${publicPath}?t=${ticketId}`
      : `${api_base}/${ticketGroupId}/share${publicPath}`;

    const response = await axios.get(url);
    const data = handleAcceptanceSchema(response.data);

    dispatch<ILoadTicketReceivingDataSuccess>({
      type: TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_SUCCESS,
      payload: (data as unknown) as IRecipientTicketInfo
    });
  } catch (error) {
    if (error.response.status !== 401) {
      dispatch<ILoadTicketReceivingDataFailed>({
        type: TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_FAILED,
        error: {
          type: ErrorTypes.TICKET_NOT_FOUND_ERROR,
          message: "Sorry, that ticket link is no longer active or has been returned to the purchaser"
        }
      });
    }
  } finally {
    // dispatch<IHideLoading>(hideLoading());
  }
};

export const updateCheckReceive = (checkReceive: boolean) => async (
  dispatch: Dispatch
) => {
  dispatch<IUpdateCheckReceive>({
    type: TicketReceivingActionTypes.UPDATE_CHECKRECEIVE_STATUS,
    payload: checkReceive
  });
};

export const updatePostStep = (postStep: string) => async (
  dispatch: Dispatch
) => {
  dispatch<IUpdatePostStep>({
    type: TicketReceivingActionTypes.UPDATE_POST_STEP,
    payload: postStep
  });
};

export const acceptTicket = () => async (
  dispatch: Dispatch,
  getState: any,
  axios: AxiosStatic
) => {
  dispatch<IAcceptTicketPending>({
    type: TicketReceivingActionTypes.ACCEPT_TICKET_PENDING
  });

  const {
    data: { ticketGroupId, ticketId },
    checkReceive
  } = getState().ticketReceiveData;
  try {
    let url = "";
    if (ticketId) {
      url = `${api_base}/${ticketGroupId}/share/accept/?t=${ticketId}&optIn=${checkReceive}`;
    } else {
      url = `${api_base}/${ticketGroupId}/share/accept/?optIn=${checkReceive}`;
    }
    const acceptRequestBody = {
      optIns: checkReceive
    };

    const response = await axios.post(url, {
      ...acceptRequestBody
    });
    dispatch<IAcceptTicketSuccess>({
      type: TicketReceivingActionTypes.ACCEPT_TICKET_SUCCESS
    });
  } catch (error) {
    const errorMessage = {
      type: ErrorTypes.AUTHENTICATION_ERROR,
      message: "Sorry, that ticket link is no longer active or has been returned to the purchaser"
    };

    dispatch<IAcceptTicketFailed>({
      type: TicketReceivingActionTypes.ACCEPT_TICKET_FAILED,
      error: errorResponseHandler(error, errorMessage) as IError
    });
  } finally {
    // dispatch<IHideLoading>(hideLoading());
  }
};

export const declineTicket = () => async (
  dispatch: Dispatch,
  getState: any,
  axios: AxiosStatic
) => {
  dispatch<IDeclineTicketPending>({
    type: TicketReceivingActionTypes.DECLINE_TICKET_PENDING
  });

  const {
    data: { ticketGroupId, ticketId }
  } = getState().ticketReceiveData;
  try {
    let url = "";
    if (ticketId) {
      url = `${api_base}/${ticketGroupId}/share/reject/?t=${ticketId}`;
    } else {
      url = `${api_base}/${ticketGroupId}/share/reject`;
    }
    const response = await axios.post(url);
    dispatch<IDeclineTicketSuccess>({
      type: TicketReceivingActionTypes.DECLINE_TICKET_SUCCESS
    });
  } catch (error) {
    const errorMessage = {
      type: ErrorTypes.AUTHENTICATION_ERROR,
      message: "Sorry, that ticket link is no longer active or has been returned to the purchaser"
    };

    dispatch<IDeclineTicketFailed>({
      type: TicketReceivingActionTypes.DECLINE_TICKET_FAILED,
      error: errorResponseHandler(error, errorMessage) as IError
    });
  } finally {
    // dispatch<IHideLoading>(hideLoading());
  }
};

export type LoadTicketReceivingDataActions =
  | ILoadTicketReceivingDataSuccess
  | ILoadTicketReceivingDataPending
  | ILoadTicketReceivingDataFailed
  | IUpdateCheckReceive
  | IUpdatePostStep
  | IAcceptTicketPending
  | IAcceptTicketSuccess
  | IAcceptTicketFailed
  | IDeclineTicketPending
  | IDeclineTicketSuccess
  | IDeclineTicketFailed;
